"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleEvent = exports.GetPageInfo = exports.GetFlashProducts = exports.GetSeoInfo = exports.GetProducts = exports.GetFrontModulesBySlugAndType = exports.GetFrontModules = exports.GetFrontPlayground = void 0;
var webapi_1 = require("../webapi");
function GetFrontPlayground(payload) {
    return webapi_1.default("page.App/GetFrontPlayground", payload);
}
exports.GetFrontPlayground = GetFrontPlayground;
function GetFrontModules(payload) {
    return webapi_1.default("page.App/GetFrontModules", payload);
}
exports.GetFrontModules = GetFrontModules;
function GetFrontModulesBySlugAndType(payload) {
    return webapi_1.default("page.App/GetFrontModulesBySlugAndType", payload);
}
exports.GetFrontModulesBySlugAndType = GetFrontModulesBySlugAndType;
function GetProducts(payload) {
    return webapi_1.default("page.App/GetProducts", payload);
}
exports.GetProducts = GetProducts;
function GetSeoInfo(payload) {
    return webapi_1.default("page.App/GetSeoInfo", payload);
}
exports.GetSeoInfo = GetSeoInfo;
function GetFlashProducts(payload) {
    return webapi_1.default("page.App/GetFlashProducts", payload);
}
exports.GetFlashProducts = GetFlashProducts;
function GetPageInfo(payload) {
    return webapi_1.default("page.App/GetPageInfo", payload);
}
exports.GetPageInfo = GetPageInfo;
function ModuleEvent(payload) {
    return webapi_1.default("page.App/ModuleEvent", payload);
}
exports.ModuleEvent = ModuleEvent;
exports.default = {
    GetFrontPlayground: GetFrontPlayground,
    GetFrontModules: GetFrontModules,
    GetFrontModulesBySlugAndType: GetFrontModulesBySlugAndType,
    GetProducts: GetProducts,
    GetSeoInfo: GetSeoInfo,
    GetFlashProducts: GetFlashProducts,
    GetPageInfo: GetPageInfo,
    ModuleEvent: ModuleEvent
};
